export enum CommunicationTypeEnum {
  LeisureReceiptRequestConfirmation = 1,
  SubscriptionConfirmation = 2,
  // ReviewRequest = 3, // non usato
  Birthday = 4,
  LeisurePreStay = 5,
  LeisurePostStay = 6,
  // OfferRequestConfirmation = 7, // non usato
  // ReviewThanks = 8, // non usato
  // PromoReview = 9, // non usato
  // PaymentConfirmation = 10, // non usato
  LeisureQuotationSend = 11,
  LeisureQuotationFollowUp = 12,
  LeisureDepositBalance = 13,
  LeisureReservationConfirmation = 14,
  LeisureStructureClosed = 15,
  LeisureNoAvailability = 16,
  NewMessageInChat = 17,
  LeisureMinimumStay = 18,
  LeisureAdvanceBalance = 19,
  LeisureSecondQuotationFollowUp = 20,
  LeisureThirdQuotationFollowUp = 21,
  LeisureCreditCardDataRequest = 22,
  LeisureQuotationCanceled = 23,
  LeisureCheckInOnline = 24,
  MiceQuotationSend = 25,
  MiceQuotationFollowUp = 26,
  MiceSecondQuotationFollowUp = 27,
  MiceThirdQuotationFollowUp = 28,
  MiceDepositBalance = 29,
  // MiceAdvanceBalance = 30, // non usato
  MiceReservationConfirmation = 31,
  MiceQuotationCanceled = 32,
  LeisurePreStayUpSell = 33,
  LeisureInStayWelcome = 34,
  LeisureInStayInfo = 35,
  LeisureInStayCheckOut = 36,
  LeisureWeMissYou = 37,
}

export const CommunicationTypeMeta: Record<
  CommunicationTypeEnum,
  {
    order: number;
    group?: "Leisure" | "Mice" | "CustomerJourney" | "Excluded";
    onlyGroup: boolean;
  }
> = {
  [CommunicationTypeEnum.LeisureReceiptRequestConfirmation]: {
    order: 1,
    group: "CustomerJourney",
    onlyGroup: false,
  },

  [CommunicationTypeEnum.SubscriptionConfirmation]: {
    order: 5,
    group: "CustomerJourney",
    onlyGroup: true,
  },
  // [CommunicationTypeEnum.ReviewRequest]: {
  //   order: 0,
  //   group: "Excluded",
  //   onlyGroup: false,
  // },
  [CommunicationTypeEnum.Birthday]: {
    order: 6,
    group: "CustomerJourney",
    onlyGroup: true,
  },
  [CommunicationTypeEnum.LeisurePreStay]: {
    order: 2,
    group: "CustomerJourney",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.LeisurePostStay]: {
    order: 7,
    group: "CustomerJourney",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.NewMessageInChat]: {
    order: 14,
    group: "CustomerJourney",
    onlyGroup: false,
  },
  // [CommunicationTypeEnum.OfferRequestConfirmation]: {
  //   order: 0,
  //   group: "Excluded",
  //   onlyGroup: false,
  // },
  // [CommunicationTypeEnum.ReviewThanks]: {
  //   order: 0,
  //   group: "Excluded",
  //   onlyGroup: false,
  // },
  // [CommunicationTypeEnum.PromoReview]: {
  //   order: 0,
  //   group: "Excluded",
  //   onlyGroup: false,
  // },
  // [CommunicationTypeEnum.PaymentConfirmation]: {
  //   order: 0,
  //   group: "Excluded",
  //   onlyGroup: false,
  // },
  [CommunicationTypeEnum.LeisureQuotationSend]: {
    order: 1,
    group: "Leisure",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.LeisureQuotationFollowUp]: {
    order: 2,
    group: "Leisure",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.LeisureDepositBalance]: {
    order: 5,
    group: "Leisure",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.LeisureReservationConfirmation]: {
    order: 8,
    group: "Leisure",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.LeisureStructureClosed]: {
    order: 11,
    group: "Leisure",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.LeisureNoAvailability]: {
    order: 12,
    group: "Leisure",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.LeisureMinimumStay]: {
    order: 13,
    group: "Leisure",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.LeisureAdvanceBalance]: {
    order: 6,
    group: "Leisure",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.LeisureSecondQuotationFollowUp]: {
    order: 3,
    group: "Leisure",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.LeisureThirdQuotationFollowUp]: {
    order: 4,
    group: "Leisure",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.LeisureCreditCardDataRequest]: {
    order: 7,
    group: "Leisure",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.LeisureQuotationCanceled]: {
    order: 9,
    group: "Leisure",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.LeisureCheckInOnline]: {
    order: 10,
    group: "Leisure",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.MiceQuotationSend]: {
    order: 1,
    group: "Mice",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.MiceQuotationFollowUp]: {
    order: 2,
    group: "Mice",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.MiceSecondQuotationFollowUp]: {
    order: 3,
    group: "Mice",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.MiceThirdQuotationFollowUp]: {
    order: 4,
    group: "Mice",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.MiceDepositBalance]: {
    order: 5,
    group: "Mice",
    onlyGroup: false,
  },
  // [CommunicationTypeEnum.MiceAdvanceBalance]: {
  //   order: 6,
  //   group: "Mice",
  //   onlyGroup: false,
  // },
  [CommunicationTypeEnum.MiceReservationConfirmation]: {
    order: 7,
    group: "Mice",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.MiceQuotationCanceled]: {
    order: 8,
    group: "Mice",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.LeisurePreStayUpSell]: {
    order: 3,
    group: "CustomerJourney",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.LeisureInStayWelcome]: {
    order: 4,
    group: "CustomerJourney",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.LeisureInStayInfo]: {
    order: 5,
    group: "CustomerJourney",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.LeisureInStayCheckOut]: {
    order: 6,
    group: "CustomerJourney",
    onlyGroup: false,
  },
  [CommunicationTypeEnum.LeisureWeMissYou]: {
    order: 8,
    group: "CustomerJourney",
    onlyGroup: false,
  }
};
